module.exports = __webpack_public_path__ + "img/Social_5.ec000335.webp";